import { RsiGaugeRowConfig } from './rsi-gauge-row.component';

export class DefaultRsiGaugeRowComponent {
    // https://xyards.atlassian.net/browse/XY-1071
    gaugeConfig: RsiGaugeRowConfig = [
        { name: 'Nasdaq 100', symbol: 'QQQ' },
        { name: 'S&P 500', symbol: 'SPY' },
        { name: 'DAX 30', symbol: 'EXS1.DE' },
    ];
}

angular.module('tradersyard').component('tyDefaultRsiGaugeRow', {
    // language=HTML
    template: `
        <ty-rsi-gauge-row config="$ctrl.gaugeConfig"/>
    `,
    controller: DefaultRsiGaugeRowComponent,
});
